import { ActionCode, Page } from './enums';

type PageActionCodes = Partial<{ [TKey in Page]: ActionCode[] }>;

const pageRequiredActionCodes: PageActionCodes = {
  [Page.BankHolidays]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.BankHolidayDates]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.BlackPoints]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Duties]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.DutyAssignment]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Exchanges]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.PHARMACY_USER_CODE],
  [Page.Planner]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Pharmacies]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.CalendarComparisonPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.PharmacyPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.PHARMACY_USER_CODE],
  [Page.SecretariatDashboard]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE],
  [Page.Secretariats]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Diagnostic]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.SecretariatPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Users]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.UserPage]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
  [Page.Zones]: [ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE],
};

export default pageRequiredActionCodes;
